import styled from "@emotion/styled/macro";
import React, { useEffect, useState } from "react";
import { BodyContentLayout } from "../../components/ui/ContentLayout";
import { useTranslation } from "react-i18next";
import CmsService from "../../services/CmsService";
import ReactMarkdown from "react-markdown";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  background: ${({ theme }) => theme.colors.white};
`;

const Page = styled.div`
  padding: 2em 0;
  h1 {
    padding-bottom: 0.5em;

    font-family: Atten Round New ExtraBold;
    font-size: 2.25rem;
    color: #325146;
  }
  h2 {
    padding-bottom: 0.5em;
    font-family: Atten Round New ExtraBold;
    font-size: 1.25rem;
    color: #325146;
  }
  h3 {
    padding-bottom: 0.5em;

    font-family: Atten Round New ExtraBold;
    font-size: 1rem;
    color: #325146;
  }
  h4 {
    padding-bottom: 0.25em;

    font-family: Atten Round New ExtraBold;
    font-size: 1rem;
    color: #325146;
  }
  h5 {
    padding-bottom: 0.5em;

    font-family: Atten Round New ExtraBold;
    font-size: 1rem;
    color: #325146;
  }

  ul {
    list-style-type: disc;
    padding: 0 0 1em 1em;
    li::marker {
      color: #5a8a79;
    }
  }
  p {
    padding-bottom: 1.25em;
  }
`;

const Legal = () => {
  const { i18n } = useTranslation();
  const [page, setPage] = useState();
  const { language } = i18n;

  useEffect(() => {
    const fetchPage = async () => {
      const api = new CmsService();
      setPage(null);
      try {
        const page = await api.getPageCollectionTypes(
          language === "eng" ? `legals?_locale=en` : `legals?_locale=${language}-BE`
        );
        setPage(page);
      } catch (e) {
        console.log(e);
      }
    };
    fetchPage();
  }, [language]);

  return (
    <Container>
      <BodyContentLayout>
        <Page>
          <ReactMarkdown children={page?.content} />
        </Page>
      </BodyContentLayout>
    </Container>
  );
};

export default Legal;
